//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			detail: {},
			id: '',
			integral: 0,
		}
	},
	onLoad(event) {
		this.id = event.id
		this.queryData()
	},
	methods: {
		//详情
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/mall/selectFromId',
				data: {
					id: this.id
				}
			}).then(res => {
				this.detail = res.data
			})
		},
		//兑换
		conversion() {
			let _this = this
			this.$ajax({
				method: 'post',
				url: '/weChat/integrals/member/selectByMemberId',
				data: {
					memberId: this.$store.state.userInfo.memberId
				}
			}).then(res => {
				this.integral = res.data
				if (this.integral >= this.detail.needIntegrals) {
					uni.showModal({
						title: this.detail.productName,
						content: '商品一经兑换不可退换，确定兑换吗?',
						success(res) {
							if (res.confirm) {
								_this.$ajax({
									method: 'post',
									url: '/weChat/integrals/member/exchage',
									data: {
										memberId: _this.$store.state.userInfo.memberId,
										id: _this.id
									}
								}).then(res => {
									uni.navigateTo({
										url: '/pages/personalCenter/myIntegral/success'
									})
								})
							}
						}
					})
				} else {
					uni.showToast({
						title: '您的积分剩余不足，暂时无法兑换。',
						icon: 'none'
					})
				}
			})
		}
	}
}
